import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let person_id = useDataValue({
    context: 'patient',
    path: 'person._id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      person_id,
    },
  }
}
